type aggregationProfitProps = {
  title: string
  amount: number | string
}
export const AggregationProfit = ({
  title,
  amount,
}: aggregationProfitProps) => {
  return (
    // 🚨 style 추가: 양 끝 정렬 (space-between) 및 수직 중앙 정렬 (center)
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <span>{title}</span>
      <span>{amount} 원</span>
    </div>
  )
}
